import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { ModalFooter, ModalBody } from "../../../../../application/modal";
import {
  Button,
  BtnType,
  Label,
  DropSelect,
} from "../../../../primitives";
import styles from "./selectUser.module.scss";
import { useModelPopup } from "../../../../../common/hooks";

const SelectUserComponent = (props) => {
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState([]);
  const popup = useModelPopup();
  const { callBack, model } = props;
  const {
    projectsReducer: {
      usersReducer: { projectUsersList },
    },
  } = useSelector((state) => state);

  const handleCancelClick = () => {
    popup.hide();
  };

  useEffect(() => {
    if (model?.assigned_to?.id) {
      setSelected([
        {
          id: model?.assigned_to?.id,
          fullName: model?.assigned_to?.full_name,
        },
      ]);
    }
  }, [model]);

  useEffect(() => {
    if (projectUsersList.length !== 0) {
      const list = projectUsersList.map(({ user }) => ({
        id: user.id,
        fullName: user.full_name,
        avatar: user.avatar,
      }));
      setOptions(list);
    }
  }, [projectUsersList]);

  const handleSaveClick = () => {
    callBack(selected[0]);
  };

  const handleOptionSelect = (values) => {
    setSelected(values.obj);
  };

  return (
    <div className={styles.selectCouncilWrp}>
      <ModalBody>
        <Label>Members</Label>
        <DropSelect
          onChange={handleOptionSelect}
          placeholder="Select"
          labelField="fullName"
          valueField="id"
          options={options}
          SelecedValues={selected}
          className={null}
        />
      </ModalBody>
      <ModalFooter>
        <Button btn={BtnType.FRAME_LESS} onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button type="submit" btn={BtnType.REGULAR} onClick={handleSaveClick}>
          Save
        </Button>
      </ModalFooter>
    </div>
  );
};

export default React.memo(SelectUserComponent);
